import React, { Component, lazy } from 'react';
import { Row, Col, Popover, Input } from 'antd';
import { Switch, Route } from 'react-router-dom';
import Headroom from 'react-headroom';
import './styles.scss';

import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer/Footer';

const Home = lazy(() => import('./scenes/Home'));
const EmpresaSQL = lazy(() => import('./scenes/EmpresaSQL'));
const ContableSQLDBF = lazy(() => import('./scenes/ContableSQLDBF'));
const Contador = lazy(() => import('./scenes/Contador'));
const ContadorSQL = lazy(() => import('./scenes/ContadorSQL'));
const ServicioCliente = lazy(() => import('./scenes/ServicioCliente'));
const Certificaciones = lazy(() => import('./scenes/Certificaciones'));
const CertifiedAssociated = lazy(() => import('./scenes/CertifiedAssociated'));
const Pagaaqui = lazy(() => import('./scenes/Pagaaqui'));
const PagaaquiContasiscorp = lazy(() => import('./scenes/Pagaaqui/contasiscorp'));
const ContadorDigital = lazy(() => import('./scenes/ContadorDigital'));
const EmpresaDigital = lazy(() => import('./scenes/EmpresaDigital'));
const IndexNegociosOnline = lazy(() => import('./scenes/NegociosOnline/index'));
const PlanNegociosOnline = lazy(() => import('./scenes/NegociosOnline/plan'));
const Renovacion = lazy(() => import('./scenes/Renovacion'));
const RenovacionContador = lazy(() => import('./scenes/RenovacionContador'));
const GestionCDPE = lazy(() => import('./scenes/GestionCDPE'));
const FEGestionCDPE = lazy(() => import('./scenes/FEGestionCDPE'));
const Eventos = lazy(() => import('./scenes/Eventos'));
const LibroReclamaciones = lazy(() => import('./scenes/LibroReclamaciones'));
const InformacionFacturacionShopify = lazy(() => import('./scenes/InformacionFacturacionShopify'));
const Congreso = lazy(() => import('./scenes/Congreso'));
const Cloud = lazy(() => import('./scenes/Cloud'));
const RenovacionEmpresa = lazy(() => import('./scenes/RenovacionEmpresa'));
const EmpresaDigitalGracias = lazy(() => import('./scenes/EmpresaDigitalGracias'));
const ContadorDigitalGracias = lazy(() => import('./scenes/ContadorDigitalGracias'));
const ColegioContadores = lazy(() => import('./scenes/ColegioContadores'));
const Referenciamiento = lazy(() => import('./scenes/Referenciamiento'));
const ReferenciamientoGratis = lazy(() => import('./scenes/ReferenciamientoGratis'));
const TalleresNegocios = lazy(() => import('./scenes/TalleresNegocios'));
const MasterClass = lazy(() => import('./scenes/MasterClass'));
const PoliticasPrivacidad = lazy(() => import('./scenes/PoliticasPrivacidad'));
const Accountech = lazy(() => import('./scenes/Accountech'));
const AccountechLima = lazy(() => import('./scenes/AccountechLima'));
const CierreContable = lazy(() => import('./scenes/CierreContable'));
const PostContador = lazy(() => import('./scenes/PostContador'));
const ContadorDemo = lazy(() => import('./scenes/ContadorDemo'));
const Sostenibilidad = lazy(() => import('./scenes/Sostenibilidad'));
const Nosotros = lazy(() => import('./scenes/Nosotros'));
const Universidades = lazy(() => import('./scenes/Universidades'));
const SafNiif = lazy(() => import('./scenes/SafNiif'));
const Sire = lazy(() => import('./scenes/Sire'));
const CursoSire = lazy(() => import('./scenes/CursoSire'));
const SolucionesContador = lazy(() => import('./scenes/SolucionesContador'));
const AcademiaContasis = lazy(() => import('./scenes/AcademiaContasis'));
const TallerCierreApertura = lazy(() => import('./scenes/TallerCierreApertura'));
const TallerPractico = lazy(() => import('./scenes/TallerPractico'));

const { TextArea } = Input;

class Web extends Component {
  state = {
    message: '',
    visible: false,
  };

  handleChangeMessage = (e, fieldName) => {
    this.setState({
      message: e.target.value,
    });
  };

  hide = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      <Row>
        <Headroom id="menu--headroom">
          <Menu props={this.props} submenu={'props'} />
        </Headroom>
        <Col className={window.location.pathname === '/cloud'?"margin_top_cloud": (window.location.pathname === '/'?"margin_top":'') }>
          <Switch>
            <Route path="/taller-practico" name="taller-practico" component={TallerPractico} />
            <Route path="/taller-cierre-apertura" name="taller-cierre-apertura" component={TallerCierreApertura} />
            <Route path="/academia-contasis" name="academia-contasis" component={AcademiaContasis} />
            <Route path="/contador-digital/soluciones-contador" name="soluciones-contador" component={SolucionesContador} />
            <Route path="/curso-sire" name="curso-sire" component={CursoSire} />
            <Route path="/consultoria-sire" name="consultoria-sire" component={Sire} />
            <Route path="/saf-niif" name="saf-niif" component={SafNiif} />
            <Route path="/universidades" name="universidades" component={Universidades} />
            <Route path="/nosotros" name="nosotros" component={Nosotros} />
            <Route path="/accountech-lima" name="AccountechLima" component={AccountechLima} />
            <Route path="/sostenibilidad" name="Sostenibilidad" component={Sostenibilidad} />
            <Route path="/demo-colegiodecontadores" name="ContadorDemo" component={ContadorDemo} />
            <Route path="/form" name="PostContador" component={PostContador} />
            <Route path="/cierre-contable" name="CierreContable" component={CierreContable} />
            <Route path="/politicas-privacidad" name="Politicas Privacidad" component={PoliticasPrivacidad} />
            <Route path="/masterclass" name="MasterClass" component={MasterClass} />
            <Route path="/talleres-negocios" name="Talleres Negocios" component={TalleresNegocios} />
            <Route path="/referenciamiento-gracias" name="Referenciamiento Gracias" component={ReferenciamientoGratis} />
            <Route path="/referenciamiento" name="Referenciamiento" component={Referenciamiento} />
            <Route path="/colegios-contadores" name="Colegios Contadores" component={ColegioContadores} />
            <Route path="/empresa-digital-gracias" name="Empresa Digital Gracias" component={EmpresaDigitalGracias} />
            <Route path="/contador-digital-gracias" name="Contador Digital Gracias" component={ContadorDigitalGracias} />
            <Route path="/contador-sql" name="Contador SQL" component={ContadorSQL} />
            <Route path="/servicio-cliente" name="Servicio Cliente" component={ServicioCliente} />
            <Route path="/certified-asociated" name="Certified Associated" component={CertifiedAssociated} />
            <Route path="/pagaaqui" name="Paga Aquí" component={Pagaaqui} />
            <Route path="/contasiscorp/pagaaqui" name="Paga Aquí" component={PagaaquiContasiscorp} />
            <Route path="/certificaciones" name="Certificaciones" component={Certificaciones} />
            <Route path="/empresa-sql" name="Empresa SQL" component={EmpresaSQL} />
            <Route path="/contable-sql-dbf" name="Contable SQL DBF" component={ContableSQLDBF} />
            <Route path="/home-contador" name="Contador" component={Contador} />
            <Route path="/contador-digital" name="Contador Digital" component={ContadorDigital} />
            <Route path="/empresa-digital" name="Empresa Digital" component={EmpresaDigital} />
            <Route path="/renovacion" name="Renovacion" component={Renovacion} />
            <Route path="/renovacion-contadores" name="Renovacion Contadores" component={RenovacionContador} />
            <Route path="/renovacion-empresas" name="Renovacion Empresas" component={RenovacionEmpresa} />
            <Route path="/gestion-cdpe" name="Gestion CDPE" component={GestionCDPE} />
            <Route path="/facturacion-electronica" name="Facturacion Electronica" component={FEGestionCDPE} />
            <Route path="/eventos" name="Eventos" component={Eventos} />
            <Route path="/informacion-facturacion-shopify" name="InformacionFacturacionShopify" component={InformacionFacturacionShopify} />
            <Route path="/negocios-online/planes" name="Planes" component={PlanNegociosOnline} />
            <Route path="/negocios-online" name="Negocios Online" component={IndexNegociosOnline} />
            <Route path="/libro-reclamaciones" name="Libro de Reclamaciones" component={LibroReclamaciones} />
            <Route path="/congreso" name="Congreso" component={Congreso} />
            <Route path="/cloud" name="Cloud" component={Cloud} />
            <Route path="/accountech" name="Accountech" component={Accountech} />
            <Route path="/home" name="Home" component={Home} />
            <Route path="/" name="Home" component={Home} />
          </Switch>
          <Footer />
        </Col>
        <Popover
          visible={this.state.visible}
          placement="topRight"
        >
          <span className='ver_web01'>
            <a href={`https://web.whatsapp.com/send?phone=+51981428779&text=Hola!%20🙂%20Quiero más información sobre el sistema contable Contasis, ¿podrías ayudarme?`} target="_blank" rel="noreferrer">
              <div className="whatsapp">{this.state.visible ? <i className="fal fa-times"></i> : <i className="fab fa-whatsapp"></i>}</div>
            </a>
          </span>
          <span className='ver_mobile01'>
            <a href={`https://wa.me/+51981428779?text=Hola!%20🙂%20Quiero más información sobre el sistema contable Contasis, ¿podrías ayudarme?`} target="_blank" rel="noreferrer">
              <div className="whatsapp">{this.state.visible ? <i className="fal fa-times"></i> : <i className="fab fa-whatsapp"></i>}</div>
            </a>
          </span>
        </Popover>
      </Row>
    );
  }
}
export default Web;
